/**
 * La cabecera de Hoy, en datos. El nivel general es la media de los niveles de área
 * (PRD 8.3): su parte decimal es lo recorrido hacia el siguiente. Se redondea a
 * centésimas porque `4.62 % 1` da `0.6200000000000001` y eso acaba en pantalla.
 */
export function tramoHaciaElSiguiente(
  nivel: number,
  media: number,
): { fraccion: number; texto: string } {
  const fraccion = Math.round((media % 1) * 100) / 100;
  const siguiente = nivel + 1;
  return fraccion === 0
    ? { fraccion: 0, texto: `Empezando el nivel ${siguiente}` }
    : { fraccion, texto: `${Math.round(fraccion * 100)} % hacia el nivel ${siguiente}` };
}

export function saludo(nombre: string): string {
  const limpio = nombre.trim();
  return limpio ? `Hola, ${limpio}` : 'Hoy';
}
